import { render, staticRenderFns } from "./SchoolLeaveEntitlementPage.vue?vue&type=template&id=ee0a828e&scoped=true&"
import script from "./SchoolLeaveEntitlementPage.vue?vue&type=script&lang=js&"
export * from "./SchoolLeaveEntitlementPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0a828e",
  null
  
)

export default component.exports